<template>
  <form @submit.prevent="onSearch" class="flex   xl:w-[360px]">
    <select
        v-model="sort"
        :class="$i18n.locale === 'ar' ? '!rounded-r-lg' : '!rounded-l-lg'"
        class="w-full px-4 py-3 rounded-none border-none bg-dark100 focus:outline-none focus:border-primary"
    >
      <option value="" disabled selected>
        {{ $t("sortBy") }}
      </option>
      <option
          v-for="option in options"
          :key="option"
          :value="option"
      >
        {{ $t(option) }}
      </option>
    </select>
    <div :class="$i18n.locale === 'ar' ? '!rounded-l-lg' : '!rounded-r-lg'"
         class="flex items-center gap-1 justify-center px-4 py-3 bg-primary text-white">
      <button
          type="button"
          @click="ascending = true"
      >
        <i class='bx bx-up-arrow-alt'></i>
      </button>
      <button
          type="button"
          @click="ascending = false"
      >
        <i class='bx bx-down-arrow-alt'></i>
      </button>
    </div>
  </form>
</template>
<script lang="ts" setup>
import {ref, onMounted, watch} from 'vue';
import {useRouter} from "vue-router";

const router = useRouter();

const sort = ref("");
const ascending = ref<boolean>(false);

defineProps<{
  options: string[];
}>()


onMounted(() => {
  const query = router.currentRoute.value.query;
  if (query.sort) sort.value = query.sort as string;
  ascending.value = query.ascending == "true";
});

const onSearch = () => {
  const prev_query = router.currentRoute.value.query;
  const query = Object.assign({}, prev_query);
  query["sort"] = sort.value;
  query["ascending"] = ascending.value ? "true" : "false";
  // A new sort starts from the first page of results.
  delete query["pageNumber"];
  router.push({query});
};

watch(sort, onSearch)
watch(ascending, onSearch)
</script>
